<template>
    <div class="sidebar-container" v-bind:class="{unfold: !collapsed}">
        <div class="top-bar"></div>
        <div class="fas fa-cog first"></div>
        <div class="fas fa-cog second"></div>
        <div class="header">
            <menutabs :sideways="true" class="hover-gray" :state="{tabs: tabs}" :tab-selected="tabSelected" @tab-select="TabSelect"></menutabs>
        </div>
        <component :is="tabSelected.view" v-bind="tabSelected.props"/>
    </div>
</template>

<script>
    import Vue from 'vue'
    import vClickOutside from 'v-click-outside'
    Vue.use(vClickOutside)
    export default {
        name: "sidebar",
        data(){
            return {
                tabSelected: {view: ''},
                collapsed: true,
            }
        },
        watch: {
            tabs: {
                immediate: true,
                handler(newVal, oldVal) {
                    let view = this;
                    if(this.tabSelected && newVal.length > 0){
                        let sameTab = newVal.find(t => t.view === view.tabSelected.view);
                        if(sameTab) this.tabSelected = sameTab;
                        else this.tabSelected = newVal[0];
                        newVal.forEach(t => t.selected = false);
                        this.tabSelected.selected = true;
                    }
                }
            }
        },
        props:{
            tabs: Array,
        },
        mounted(){
            window.addEventListener('mousedown', this.CollapseWatch);
        },
        beforeDestroy(){
            window.removeEventListener('mousedown', this.CollapseWatch);
        },
        methods: {
            TabSelect(tab){
                if(tab.selected && !this.collapsed){
                    this.collapsed = true;
                } else {
                    this.tabs.forEach(t => t.selected = false);
                    tab.selected = true;
                    this.tabSelected = tab;
                    this.collapsed = false;
                } 
            },
            CollapseWatch($event){
                if(!window.mouse.element.closest('.sidebar-container') && !window.mouse.element.closest('.c-dropdown') && !window.mouse.element.closest('.popup-alert') ) this.collapsed = true;
            }
        }
    }
</script>

<style scoped>
.sidebar-container{
    position: fixed;
    bottom: 0;
    right: -700px;
    height: calc(100% - var(--header-height) - var(--tab-menu-height) + 1px) !important;
    width: 700px;
    background: var(--contrast-1);
    transition: 0.2s;
    z-index: 10;
}
.sidebar-container.unfold{
    right: 0px;
}

.top-bar{
    background: var(--contrast-3);
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 110px;
}

.fa-cog.first{
    color: var(--contrast-1);
    font-size: 200px;
    position: absolute; 
    left: 200px;
    top: 10px;
    pointer-events: none;
}

.fa-cog.second{
    color: var(--contrast-1);
    transform: rotate(30deg);
    font-size: 100px;
    position: absolute; 
    left: 400px;
    top: 5px;
    pointer-events: none;
}

.header{
    position: absolute;
    top: 245px;
    left: -28px;
    width: 30px;
    margin: auto;
    display: flex;
    align-items: center;
    height: fit-content;
}
</style>
